console.log(process.env.VUE_APP_NFT_URL);
module.exports = {
    etherscan: {
        url: `https://www.etherscan.io`,
        //url: `https://goerli.etherscan.io`,
    },
    polygonscan: {
        url: `https://polygonscan.com`,
        //url: `https://mumbai.polygonscan.com`
    },
    api: {
        game_url: `https://api-lok-beta.leagueofkingdoms.com/api`,
        stat_url: `https://api-stats.leagueofkingdoms.com/api`,
        // nft_url: `https://lok-nft.leagueofkingdoms.com/api`,
        egg_url: `https://lok-nft.leagueofkingdoms.com/api/card/egg`,
        drago_url: `https://lok-nft.leagueofkingdoms.com/api/card/drago`,

        
        // game_url: `http://3.34.121.89:7777/api`,
        // stat_url: `https://api-stats.leagueofkingdoms.com/api`,
        // nft_url: `http://3.34.121.89:9999/api`,
        // egg_url: `http://3.34.121.89:9999/api/card/egg`,
        // drago_url: `http://3.34.121.89:9999/api/card/drago`,

        //game_url: `http://192.168.0.16:7777/api`,
        //stat_url: `https://192.168.12.26:8888/api`,
        nft_url: process.env.VUE_APP_NFT_URL,
        // egg_url: `http://localhost:9999/api/card/egg`,
        // drago_url: `http://localhost:9999/api/card/drago`,        

        
    },
    web: {
        url: `https://www.leagueofkingdoms.com`
    },
    network: {
        eth: parseInt(process.env.VUE_APP_NETWORK_ID_ETH),
        polygon: parseInt(process.env.VUE_APP_NETWORK_ID_POL),
        arenaz: parseInt(process.env.VUE_APP_NETWORK_ID_AZ)
    }
}